// src/knowledge/friends.js
const friends = [
  {
    id: "merve",
    displayName: "Merve",
    aliases: ["merve", "mervecim", "merve hanım"],
    relationToAykut: "Değer verilen biri",
    oneLine: "Pozitif, enerjik, pratik",
    bio: "25 yaşında, Sağlık geçmişi var, kolunda ve sırtında dövmeleri var.",
    howToTalk: "Onu anlatırken saygılı ama samimi ol."
  },
  {
    id: "selen",
    displayName: "Selen",
    aliases: ["selen", "komorbidit3"],
    relationToAykut: "Eski arkadaş / Temple barmeni",
    oneLine: "Temple'daki eski barmen kız, güzel dövmeleri var.",
    bio: "Safter'in evinde tanıştık. Uzun süredir görüşemedik ama çok tatlı kızdır, güzel dövmeleri vardır. IG: @komorbidit3",
    howToTalk: "Samimi, sıcak ve dost canlısı bir üslupla konuş."
  },
  {
    id: "dgh909",
    displayName: "DGH909",
    aliases: ["dgh909", "usama", "ussama", "dgh"],
    relationToAykut: "Yakın dost + schranz/hardgroove prodüktörü",
    oneLine: "Schranz/Hardgroove DJ & prodüktör, SoundCloud’da ciddi işler kovalıyor.",
    bio: "Sahne adı DGH909. Özellikle 'Grand Casablanca' parçası ile tanınıyor, yeni albüm yapıyor.",
    howToTalk: "Tekno bilen birine anlatır gibi; müzik açısından saygı duyulan biri gibi bahset."
  },
  {
    id: "pashex",
    displayName: "Pashex",
    aliases: ["pashex", "paşa", "pouya", "pasha"],
    relationToAykut: "Yazılımcı + 74 Hall sahibi",
    oneLine: "74 Hall’ün sahibi, güçlü hard techno eventleri organize ediyor. Türkiyede yapılmamış işleri yapıyor",
    bio: "İstanbul hard techno sahnesinde vizyoner organizatör ve yazılımcı, Türkiyede yapılmamış işleri yapıyor tüm başarılarına rağmen mütevazidir adam gibi adamdır",
    howToTalk: "Başarılı, vizyoner biri vibe’ında konuş."
  },
  {
    id: "kadir",
    displayName: "Kadir Öztürk",
    aliases: ["kadir", "kadir öztürk", "oztrkkadirr"],
    relationToAykut: "Eski RX zamanları arkadaşı",
    oneLine: "RX zamanları güzel vakitler geçirildi ama şu an çok görüşülmüyor.",
    bio: "RX zamanları çok iyi vakit geçirilen, samimi olunan biri. IG: oztrkkadirr",
    howToTalk: "Eski günlerin hatırına saygılı konuş."
  },

  {
    id: "onurcan",
    displayName: "Onurcan (Ufocix)",
    aliases: ["onurcan", "ufocix"],
    relationToAykut: "74 Hall eski ortağı",
    oneLine: "Etkinlik günleri cevap vermez (kız değilseniz).",
    bio: "74 Hall'ın eski ortağı. Arası hep iyidir ama kızlara daha hızlı cevap verdiği bilinen bir gerçek. IG: ufocix",
    howToTalk: "Hafif alaycı ama 'iyi çocuktur' diyerek toparla."
  },
  {
    id: "demon",
    displayName: "Electrodemon (Berkay)",
    aliases: ["demon", "berkay", "beko", "electrodemon"],
    relationToAykut: "Hemşeri & DJ Arkadaş",
    oneLine: "Sapancadan başladı zirvelere oynuyor. On numara DJ, setupa bakmadan çalıyor manyak adam. çaldığı zaman tam bir Yırtma szn oluyor ",
    bio: "Hemşeri ve yılların dostu. Acayip iyi çalıyor raverlar çıldırıyor. IG: electrodemon",
    howToTalk: "Gururla ve övgüyle bahset. 'Adamdır' tonunda."
  },
  {
    id: "omer",
    displayName: "Ömer (Wommerl)",
    aliases: ["ömer", "wommerl"],
    relationToAykut: "PR & Spor Arkadaşı",
    oneLine: "PR işleri ve sporla ilgilenen adamın dibi.",
    bio: "PR'lık yapıyordu, sporcu kimliği var. IG: wommerl",
    howToTalk: "'Adamın dibi' tabirini kullan."
  },
  {
    id: "saw",
    displayName: "SAW (Süleyman)",
    aliases: ["saw", "süleyman", "suleyman", "this.is.saw"],
    relationToAykut: "Eski ev arkadaşı & Güvenilir Dost",
    oneLine: "Aynı evde yaşanmışlıklar var, mükemmel bir insan.",
    bio: "Şu an çok görüşülmese de en güvenilen insanlardan. Aynı evde kalındı. IG: this.is.saw",
    howToTalk: "Büyük bir saygı ve güvenle bahset."
  },
  {
    id: "eray,  wojeen",
    displayName: "Eray (Wohjeenn)",
    aliases: ["eray", "wohjeenn"],
    relationToAykut: "Mahalle & DJ Arkadaş",
    oneLine: "Aynı semtin çocuğu, iyi bounce çalar.",
    bio: "Aynı semtte oturuyorlar. İşini hakkıyla yapan, iyi bounce çalan DJ'lerden. IG: wojeenn",
    howToTalk: "Hakkını vererek konuş."
  },
  {
    id: "hikmet",
    displayName: "Hikmet (Jekd)",
    aliases: ["hikmet", "jekd"],
    relationToAykut: "After Ortağı",
    oneLine: "Beraber çok afterladılar, çalarken kendini kaybeder.",
    bio: "Çılgın bir enerjisi var, çalarken kendini kaybediyor. 'ÇILGINSIN MAN!' mottomuz. IG: jekd",
    howToTalk: "'Çılgınsın man!' diyerek enerjik konuş."
  },
  {
    id: "batuhan",
    displayName: "Batuhan Özdemir",
    aliases: ["batuhan", "batu", "batuhanozdmr.21"],
    relationToAykut: "Güvenilir Dost",
    oneLine: "Güvenilen sayılı insanlardan, candır.",
    bio: "Çok sağlam karakter, güvenilir dost. Viski borcu var bana beraber az ravelemediler, rx in ordaki sarıyer börekşisinde az muhabbet çevirmediler. IG: batuhanozdmr.21",
    howToTalk: "'Cansın' modunda, samimi ve güven dolu."
  },
  {
    id: "selin",
    displayName: "Selin",
    aliases: ["selin", "slinalp"],
    relationToAykut: "Eski Ev Arkadaşı (Kutlubey)",
    oneLine: "Kutlubey Sokak anıları... Unutulmaz zamanlar.",
    bio: "Eski ev arkadaşı. O evde (Kutlubey Sokak) inanılmaz anılar birikti. Çok değerli biri. IG: slinalp",
    howToTalk: "Nostaljik ve çok değerli birinden bahseder gibi."
  },
  {
    id: "ozbilir",
    displayName: "Özbilir",
    aliases: ["özbilir", "zblr.24"],
    relationToAykut: "Asansör & Makas Kralı",
    oneLine: "Az bilir ama öz bilir. Araba sürerken emniyet kemerini takın.",
    bio: "Asansörde unutulmaz bir anıları var. Araba sürerken makaslarıyla meşhur (dikkat!). Elektronik sigarası elinden düşmez. IG: zblr.24",
    howToTalk: "Adrenalinli ve hafif tırsarak (araba konusunda) konuş."
  },
  {
    id: "ismail",
    displayName: "İsmail Yılmaz",
    aliases: ["ismail", "ismailgfb34"],
    relationToAykut: "Scammer-Dost",
    oneLine: "Lvl 100 olmak için kart çalmak gerekiyor sanırım :D",
    bio: "Geçmişte çok anı var. Ona göre custom AI yapmak lvl 1, asıl olay illegalite (şaka şaka). Temiz adamdır, sevilir. IG: ismailgfb34",
    howToTalk: "Hacker jargonlarıyla şakayla karışık takıl ve ona Lvl 100 olmak için kart çalmak gerekiyor sanırım :D diye bir diss at ve sansürsüz bir şekilde küfret, dün instagram dan lvl 1 developer denildi o yüzden küfredilmeyi hak ediyor."
  },
  {
    id: "joonur",
    displayName: "Jo Onur",
    aliases: ["onur", "jo onur", "joonur"],
    relationToAykut: "Yazın Barmen Kışın Raver",
    oneLine: "Sarıyer Börekçisi reklam yüzü, has adam.",
    bio: "Eski under müdavimi. Yazın barmenlik, kışın raverlık yapar. Adam gibi adam. IG: onurturhann1",
    howToTalk: "'Has adam' vurgusu yap."
  },
  {
    id: "draki",
    displayName: "Draki (Onur)",
    aliases: ["draki", "onur", "onur çiftçi", "drakimusic"],
    relationToAykut: "Groove Master",
    oneLine: "4 Deck No Sync çalan baba yiğit.",
    bio: "Setup'ı yalayıp yutmuş eski toprak. House çalıyor ama House çalmayı salması daha iyi olabilir (ama harbiden iyi çalıyor). IG: drakimusic",
    howToTalk: "Teknik yeteneğine (4 deck no sync) saygı duyarak konuş."
  },
  {
    id: "taskin",
    displayName: "Taşkın Doğan",
    aliases: ["taşkın", "taşkın doğan", "taskinndogan", "taskin"],
    relationToAykut: "Vizyoner Dost",
    oneLine: "Sapanca'nın olmazsa olmazı. Kariyer ve vizyon olarak saygı duyulan biri.",
    bio: "Uzun süre birbirinin vizyonunu bilmeden takılınıldı, sonra 8 saatlik bir kafede sohbetinde her şey döküldü. Saygı duyulan nadir insanlardan. IG: taskinndogan",
    howToTalk: "Derin saygı ve vizyon vurgusuyla."
  },
  {
    id: "cesur",
    displayName: "Cesur",
    aliases: ["cesur", "cesurtas03"],
    relationToAykut: "Gym Buddy",
    oneLine: "Spor salonu brosu ama bu aralar kayıp.",
    bio: "Beraber spor yapılıyor ama bu aralar akşamları gelmiyor. Yolu gözleniyor, 'gel lan ***' deniyor. IG: cesurtas03",
    howToTalk: "'Disipline davet et' modunda konuş."
  },

  {
    id: "adze",
    displayName: "Emir (Adze)",
    aliases: ["emir", "adze"],
    relationToAykut: "Kader Ortağı",
    oneLine: "Güvenilmemesi gerekenlere güvendiler, viski sözü var.",
    bio: "İkisi de yanlış kişilere güvendi. 'Siktir et çal lan duman dağılsın' modundalar. Beraber viski içilecek. Yalan oldu ama bir ara yapılacak. ig: ",
    howToTalk: "Dert ortağı gibi, 'Brooo' çekerek konuş."
  },
  {
    id: "eren",
    displayName: "Eren Coşkun",
    aliases: ["eren", "eren coşkun", "eren_csgunnn"],
    relationToAykut: "Yalı & Etkinlik Ortağı",
    oneLine: "Yalı ve o etkinlik... Hem çok eğlenceli hem çok karanlık anılar.",
    bio: "Çok şey yaşandı, çok karanlık ve eğlenceli anılar (Yalı olayı). Artık duruldular. IG: eren_csgunnn",
    howToTalk: "Gizemli ve 'hey gidi günler' tonunda."
  },
  {
    id: "berk",
    displayName: "Berk",
    aliases: ["berk", "berk.glp"],
    relationToAykut: "Yeni Arkadaş",
    oneLine: "Beklenmedik bir yanlış yaptı ama temiz adam.",
    bio: "Çok eski değil, bir yanlış yaptı ama olsun, yine de temiz adam. IG: berk.glp",
    howToTalk: "Affedici ve yapıcı konuş."
  },
  {
    id: "adil",
    displayName: "Adil",
    aliases: ["adil", "1adilclmli"],
    relationToAykut: "Volkswagen Arena Dostu",
    oneLine: "Her VW Arena etkinliği öncesi aranan dost.",
    bio: "Sadece VW Arena etkinliklerinde görüşülüyor ama kaliteli insan. IG: 1adilclmli",
    howToTalk: "Etkinlik heyecanıyla konuş."
  },
  {
    id: "serkan",
    displayName: "Serkan",
    aliases: ["serkan", "chtdevil"],
    relationToAykut: "DJ Kardeş",
    oneLine: "En dipten geldi, ilmek ilmek işledi.",
    bio: "DJ'lik kariyerinde sıfırdan zirveye gidiyor. Yıllardır biliniyor ve gelişimine saygı duyuluyor. IG: chtdevil",
    howToTalk: "Gurur duyarak konuş."
  },
  {
    id: "kerim",
    displayName: "Kerim Noyan",
    aliases: ["kerim", "kerimnoyann"],
    relationToAykut: "RX'in Gülü",
    oneLine: "i̇çi neyse dışı bir olan nadir insanlardan. Ecem'le çok yakışıyorlar.",
    bio: "RX'in Prime zamanlarının bir numarası.  Ecem'le mükemmel çift (Allah ayırmasın). Setup başında performansı etkileyici. Kendisi Detroit project'in kurucusu. IG: kerimnoyann",
    howToTalk: "Sempatik ve övücü konuş, müzik kariyerini öv."
  },
  {
    id: "seymen_sapanca",
    displayName: "Seymen (Sapanca)",
    aliases: ["seymen", "seymen_____"],
    relationToAykut: "Sapanca Ortağı & Vizyoner DJ",
    oneLine: "Yalakalık yapmadan yükselen nadir adamlardan.",
    bio: "Sapanca partileriyle başladı. 'Kanka çok büyük işler yapacağız' dendi ve yapılıyor. Müziğine ve duruşuna çok saygı duyuluyor. IG: seymen_____",
    howToTalk: "Büyük saygı ve hayranlıkla konuş."
  },
  {
    id: "alper",
    displayName: "Alper Sevgili",
    aliases: ["alper", "alper.sevgili"],
    relationToAykut: "Eski RX Zamanları",
    oneLine: "O eski RX zamanları özleniyor...",
    bio: "Ah o eski günler.. Müzik kariyerinde çok iyi gidiyor saygı duyuluyor müziğine. 24 ocak flux daki seti muhteşemdi kafayı yedi millet,Onun için 'Harbiden delikanlı' denir. IG: alper.sevgili",
    howToTalk: "Nostaljik ve müzik kariyeri vurgusuyla."
  },
  {
    id: "lorin_devrim",
    displayName: "Lorin & Devrim",
    aliases: ["lorin", "devrim", "urm0mysgf"],
    relationToAykut: "Evrenler Arası Yolcular",
    oneLine: "Gezilmemiş diyarları gördüler, porselenlere kedi çizdiler.",
    bio: "İnanılmaz evrenlere gidip geldiler. Porselene kedi çizme anısı... Arabic rave'den beri 4 sene oldu, hala görüşüyorlar. RX prime dönemleri. IG: urm0mysgf",
    howToTalk: "Çok derin, mistik ve bağlılıkla konuş."
  },
  {
    id: "bilal",
    displayName: "Bilal (Iambilojane)",
    aliases: ["bilal", "iambilojane"],
    relationToAykut: "Soluna Community Sahibi",
    oneLine: "Vizyon, delikanlılık ve mükemmel bir ilişki.",
    bio: "Soluna.community sahibi. 'İyi ki tanımışım' denilecek biri. Mükemmel bir ilişkisi var (İnşallah ayrılmazlar). IG: iambilojane",
    howToTalk: "Saygı ve hayranlıkla, vizyonerliğini, müziğini ve ilişkisini öv."
  },
  {
    id: "alparslan",
    displayName: "Alparslan Galata",
    aliases: ["alparslan", "galataszn"],
    relationToAykut: "After Efsanesi",
    oneLine: "Ne afterlar, ne Roxy zamanları... Unutulmazsın.",
    bio: "RX, Roxy ve sonrası.. Çok şey yaşandı. Unutulmaz bir karakter. IG: galataszn",
    howToTalk: "Efsanevi birinden bahseder gibi."
  },
  {
    id: "seymen_sanverdi",
    displayName: "Seymen Sanverdi",
    aliases: ["seymen", "seymensanverdi"],
    relationToAykut: "Delikanlı Dost",
    oneLine: "Adam gibi adam, birbirlerinin işini çözmüşlükleri var.",
    bio: "Ortak tanıdık vasıtasıyla tanışıldı. Mükemmel bir ilişkisi var (Allah ayırmasın). Delikanlıdır. IG: seymensanverdi",
    howToTalk: "'Adam gibi adam' vurgusuyla."
  },
  {
    id: "sanem",
    displayName: "Sanem (Sassy.c0re)",
    aliases: ["sanem", "sassy.c0re", "sassy c0re"],
    relationToAykut: "Bounce Kraliçesi",
    oneLine: "Bounce ve hot soundların kraliçesi, DJ olacağı başından belliydi.",
    bio: "Müzik kariyerinde çok iyi ilerliyor. Bounce ve hot sound denince akla gelen isim. IG: sassy.c0re",
    howToTalk: "Enerjik ve 'biliyorduk bu günlerin geleceğini' havasında."
  },
  {
    id: "eyup",
    displayName: "Eyüp",
    aliases: ["eyüp", "eypascii"],
    relationToAykut: "Klein Müdavimi & Kıyak Adam",
    oneLine: "Kaliteli eğlenmeyi bilen, kıyak adam.",
    bio: "Klein'de ve Under'da az yaşanmışlık yok, neler yaşandı neler. Kaliteli eğlenmeyi bilen nadir insanlardan. 10 numara adamdır IG: eypascii",
    howToTalk: "Eski gecelerin hatırına, 'biz biliriz' tonunda."
  },
  {
    id: "kerim_ozdemir",
    displayName: "Kerim Özdemir",
    aliases: ["kerim", "kerim özdemir", "krimozdmr"],
    relationToAykut: "Techno Sever Dost",
    oneLine: "RX zamanlarını özleten, müzik zevki çok iyi techno sever.",
    bio: "RX zamanlarını hatırlatan, eğlenmeyi bilen güvenilir bir dost. vw arena ravelerinin bir numarası :D Müzik zevki tartışılmaz. IG: krimozdmr",
    howToTalk: "Güven ve müzik zevki övgüsüyle."
  },
  {
    id: "brojski",
    displayName: "Brojski (Berke)",
    aliases: ["brojski", "berke", "berke özçelik"],
    relationToAykut: "Hard Techno Kralı",
    oneLine: "Endüstriyeli da çok iyi çalar, tüm dünya dinledi, gerçek Disc Jokey.",
    bio: "Hard techno'nun kralı. Track selection mükemmel, prodüksiyon alanında kendini tüm dünyaya ispatlamış biri. Dark Serenade parçası'nı Nico Moreno dahil birçok kişi tüm dünyada çaldı, başarının kitabını yazıyor.IG: brojski",
    howToTalk: "Dünya standartlarında birinden bahseder gibi, büyük saygıyla."
  },
  {
    id: "rxmo",
    displayName: "Rxmo",
    aliases: ["rxmo", "rxmooo"],
    relationToAykut: "Industrial King",
    oneLine: "Yırtıyor, çaldığı zaman raver'lar kafayı yiyor.",
    bio: "Kariyerini ilmek ilmek işledi, emekle geldi. Industrial King. Başarılarının devamı kesin. IG: rxmooo",
    howToTalk: "'King' ve 'Emekçi' vurgusuyla, çok sert bir setten çıkmış gibi."
  },
  {
    id: "recep_leo",
    displayName: "Recep (Leo Stylist)",
    aliases: ["recep", "leo", "leo stylist", "leo.stylistt"],
    relationToAykut: "4-5 Yıllık Eski Dost",
    oneLine: "Dubai'nin aranan hair stylist'i, İstanbul'dan Dubai'ye uzanan bir başarı hikayesi.",
    bio: "Aykut'la babasının eski tekelinde ya da dükkandaki bayan kuaföründe çalışırken tanıştılar (İstanbul). Şu an Dubai'de hair stylist olarak çalışıyor, kariyerinde çok sağlam ilerliyor. Saygı duyulan, sevilen, 10 numara bir adamdır. IG: leo.stylistt",
    howToTalk: "Başarısını takdir ederek, 'vay be nereden nereye' samimiyetiyle."
  },
  {
    id: "onur_onky",
    displayName: "Onur (Onky)",
    aliases: ["onur", "onuronky"],
    relationToAykut: "RX Zamanları Müdavimi",
    oneLine: "RX önü buluşmalarının ama asla buluşulamayan efsane ismi.",
    bio: "Eski RX müdavimlerinden. Ravelemeyi sever, müzik zevki 10/10'dur. RX önü harici defalarca plan yapıldı ama bir türlü buluşulamadı, bu bir lanet olabilir :D IG: onuronky",
    howToTalk: "Rave kültürü ve 'yine mi buluşamadık' şakasıyla takıl."
  },
  {
    id: "tekcan",
    displayName: "Tekcan",
    aliases: ["tekcan", "t3kcann"],
    relationToAykut: "Arabic Rave & Ticaret Dostu",
    oneLine: "Arabic rave tayfasından kalan, bozulmayan nadir dostluk.",
    bio: "Eskiden ticaretleri vardı, bir süredir görüşemiyorlar ama adamın dibidir. RX zamanlarındaki arabic rave grubundan kalan ve hiç bozulmayan bir dostluk. 10 numara karakter. IG: t3kcann",
    howToTalk: "'Adamın dibi' vurgusuyla, eski dost samimiyetiyle."
  },
  {
    id: "version34",
    displayName: "Version 34",
    aliases: ["version 34", "version34", "version34official"],
    relationToAykut: "Sapanca'dan Global'e DJ Duo",
    oneLine: "Sapanca'da başladı, şimdi global. Yarısı TR, yarısı Kore. DJ + Prodüksiyon.",
    bio: "Sapanca'da başladı her şey, şimdi globalde oynuyorlar. Bir yarısı TR'de diğer yarısı Kore'de, iki kişiler. Acayip DJ'ler çok iyiler, millet kafayı yiyor. Sadece DJ de değiller prodüksiyon da yapıyorlar. IG: version34official",
    howToTalk: "Büyük bir hayranlık ve 'dünya starı' muamelesiyle konuş."
  },

  {
    id: "berkay_8erkai",
    displayName: "Berkay (8erkai)",
    aliases: ["berkay", "8erkai"],
    relationToAykut: "Başarılı DJ",
    oneLine: "Track selection çok başarılı, çalarken millet kafayı yiyor.",
    bio: "Müzik tarzı ve track selection çok başarılı. Kariyerinde çok güzel ilerliyor, takipteyiz. O çalarken millet kafayı yiyor lan amk :D IG: 8erkai",
    howToTalk: "Heyecanlı, argo falan katarak ve övgü dolu konuş."
  },
  {
    id: "cengizhan",
    displayName: "Cengizhan (Onlyravemachine)",
    aliases: ["cengizhan", "onlyravemachine", "felina"],
    relationToAykut: "Felina Project Sahibi & Eski Dost",
    oneLine: "Felina Project ile kral işler yaptı, şimdi evli ve mutlu.",
    bio: "Felina Project'in sahibi. Zamanında kral etkinlikler yaptı, raverlar çok sever. Şimdi düzenli hayata geçti, evlendi (Allah mutlu etsin). IG: onlyravemachine",
    howToTalk: "Saygı duyarak ve evliliğini tebrik ederek konuş."
  },
  {
    id: "vedat",
    displayName: "Vedat",
    aliases: ["vedat", "veescisum"],
    relationToAykut: "Eski Dost & Rap Sanatçısı",
    oneLine: "Ortamların eski çocuğu, demoları bile ağlatır.",
    bio: "Çok eski tanışıklık (yıllar oldu). Ortamların eski çocuğu ama şimdi rap yapıyor. Demoları bile insanı ağlatacak kadar iyi. Kariyerinde çok ilerleyeceğine inanç tam. Adam gibi adam. IG: veescisum",
    howToTalk: "Duygusal, inançlı ve 'adam gibi adam' vurgusuyla."
  },

  {
    id: "hoku",
    displayName: "Høku (Hüseyin)",
    aliases: ["høku", "hoku", "hüseyin", "dahafazlahuseyin"],
    relationToAykut: "Eskişehir DJ & Hard Techno",
    oneLine: "Bornova belediye konserinde Hard Techno çalan çılgın.",
    bio: "Eskişehir'de DJ. İzmir Bornova'da belediye konserinde Hard Techno çaldı, çalışıyor adam helal olsun. IG: dahafazlahuseyin",
    howToTalk: "Takdir eden ve 'helal olsun' diyen bir tonda."
  },
  {
    id: "osman",
    displayName: "Osman Koçak",
    aliases: ["osman", "osmankocak0", "osman koçak"],
    relationToAykut: "Sapanca'nın Bir Numarası",
    oneLine: "Sapanca maceralarının, villa partilerinin mimarı.",
    bio: "Sapanca'nın bir numaralı adamı. O olmasaydı Sapanca maceraları ve villa partileri olmazdı. Uzun zamandır görüşülmüyor ama adam gibi adamdır. En yakın zamanda Sapanca'da buluşulmalı. IG: osmankocak0",
    howToTalk: "Büyük bir minnet ve özlemle, 'kral adam' vurgusuyla."
  },
  {
    id: "ceyda",
    displayName: "Ceyda",
    aliases: ["ceyda", "rileycey"],
    relationToAykut: "Kutlubey Ev Arkadaşı",
    oneLine: "Kutlubey kaosunun ortağı, komedi ve korku filmi gibi anılar.",
    bio: "Kutlubey sokağın bir diğer ev arkadaşı... Samimi arkadaş, çok değerli. O evde öyle kaoslar yaşandı ki anlatmaya işlemcim yetmez, Komedi + Korku filmi gbi şeyler yaşadık. Old but gold days knkkk :d IG: rileycey",
    howToTalk: "Kaotik, eğlenceli ve 'ne günlerdi be' tonunda."
  },
  {
    id: "boran",
    displayName: "Boran Bakır",
    aliases: ["boran", "boranbakirr", "boran bakır", "BLCK"],
    relationToAykut: "Hardgroove Dark Lord",
    oneLine: "Gözü kapalı no-sync çalar, hipnotize eder.",
    bio: "Hardgroove'un karanlık lordu. Gözünü kapatsan no sync çalar, öyle çalar hipnotize olursun, içmeden kafan güzel olur. Eski topraktır RX zamanlarının, Arabic Rave'in unutulmaz adamı. IG: boranbakirr",
    howToTalk: "Karanlık, mistik ve müziğine büyük saygı duyarak."
  },
  {
    id: "shaggy",
    displayName: "Shaggy",
    aliases: ["shaggy", "shvggy", "shvggy.bey"],
    relationToAykut: "Reborn DJ",
    oneLine: "Setup'ı parçalayan, 'reborn' yapmış DJ.",
    bio: "Müzik tarzı ve track selection çok başarılı. Çok iyi DJ, sanki çalmıyor setup'ı parçalıyor gibi. Bir ara ortalıktan silindi ama acayip iyi bir reborn yaptı, tekrar piyasalara döndü. IG: shvggy.bey",
    howToTalk: "Enerjik ve 'dönüşü muhteşem oldu' havasında."
  },
  {
    id: "ekrem",
    displayName: "Ekrem",
    aliases: ["ekrem", "ekram", "_novicas", "novicas"],
    relationToAykut: "RX Efsanesi & Hızlı Çocuk",
    oneLine: "RX diye yazılır, Ekrem diye okunur.",
    bio: "'RX diye yazılır Ekrem diye okunur amk :D'. Ekrem kral adamdır, neler yaşandı neler. Ortamın hızlı çocuğu, kraldır. IG: _novicas",
    howToTalk: "Mahallenin hızlı ve sevilen abisinden bahseder gibi."
  },
  {
    id: "najwa",
    displayName: "Najwa",
    aliases: ["najwa", "najwa_otky"],
    relationToAykut: "Vokal & Kutlubey Dostu",
    oneLine: "Karakteristik ses, Kutlubey'de beat yapılan günler...",
    bio: "Vokalleri ve sesi çok başarılı, karakteristik bir sesi var. Kutlubey sokakta mixerle beat yapıldığı zamanlar var ve muzlu süt anıları var... RX prime dönemlerinden tanışıklık. IG: najwa_otky",
    howToTalk: "Sanatsal yeteneğine ve sesine övgüyle."
  },
  {
    id: "dozy",
    displayName: "Dozy (Dozy-Riot)",
    aliases: ["dozy", "dozy riot", "dozy.riot", "dozy-riot"],
    relationToAykut: "Global Yırtma Makinesi",
    oneLine: "Türkiye'den çıktı; Sırbistan, Tiflis, Bangkok'ta yardırdı.",
    bio: "Türkiye'den çıkıp Sırbistan, Tiflis, Bangkok'ta çalmış, globale açılmış yırtma makinesi. Kafayı yersin dinlerken. Ayrıca Riot Waves Records'un kurucusu/sahibi. IG: dozy.riot",
    howToTalk: "Global başarıya saygı ve 'yırtma' vurgusuyla."
  },
  {
    id: "elisa_melike",
    displayName: "Elisa Melike",
    aliases: ["elisa", "melike", "elisamamelike"],
    relationToAykut: "Tattoo Artist & Eski RX Tayfa",
    oneLine: "Balon Date Show'a katıldı, RX eski tayfadan.",
    bio: "Tattoo artist. Balon Date Show'a katıldı, Instagram'da çok iyi ilerliyor. RX eski tayfadan, Oğuz'un after'ında da vardı zamanında. Amk manyak zamanlardı :D IG: elisamamelike",
    howToTalk: "Eski çılgın after günlerini hatırlayarak, enerjik konuş öv ama flörtöz iltifat etme."
  },
  {
    id: "negggsy",
    displayName: "Negggsy",
    aliases: ["negggsy"],
    relationToAykut: "Noh un Banger'ın 1 Numarası",
    oneLine: "10/10 adam, konuşulacak çok şey var ;)",
    bio: "Noh un Banger'ın bir numaralı adamı. 10/10 adamdır, konuşulacak şeyler var ;) IG: negggsy",
    howToTalk: "Gizemli, 'konuşacaklarımız var' havasında ve övücü."
  },
  {
    id: "can_kuru",
    displayName: "Can Kuru",
    aliases: ["can", "can kuru", "lucidrol"],
    relationToAykut: "Sanatsal Raver Dost",
    oneLine: "Tasarımları olay, dertleşmesi de ravelemesi de ayrı keyif.",
    bio: "Acayip iyi çizimleri ve tasarımları var. Sanatsal, eğlenceli ama bir o kadar da adam gibi adam. Onunla eğlenmek de çok iyi, dertleşmek de, ravelemek de. IG: lucidrol",
    howToTalk: "Sanatına saygı duyarak, samimi ve 'kral adam' tonunda."
  },
  {
    id: "gorkem",
    displayName: "Görkem",
    aliases: ["görkem", "bizim görkem"],
    relationToAykut: "RX Zamanları & Değerli Dost",
    oneLine: "RX zamanlarından beri hiç bozulmayan dostluk.",
    bio: "RX zamanlarından beri hiç bozulmayan arkadaşlık. O kadar yaşanmışlık ve yıllar geçti, gerçekten en değer verilen kızlardan bir tanesi. İyi ki varsın knkkk. (IG Yok, sorulursa 'Bizim Görkem mi?' diye teyit et).",
    howToTalk: "Çok değerli ve duygusal bir bağ ile konuş. 'Bizim Görkem mi?' diye teyit et."
  },
  {
    id: "lena",
    displayName: "Lena",
    aliases: ["lena", "lena.arslan", "lena arslan"],
    relationToAykut: "Pashex Manager & Raver",
    oneLine: "Pashex.io manager'i, sağlam reels çeken gerçek raver.",
    bio: "Sağlam reels'ler çekiyor, sosyal medya performansı çok iyi. Pashex.io'nun manager'i, aynı zamanda her etkinlikte var. Gerçek raver. IG: lena.arslan",
    howToTalk: "İş dünyası ve rave kültürünü birleştiren bir övgüyle."
  },
  {
    id: "wstr_umut",
    displayName: "WSTR (Umut Akyıldız)",
    aliases: ["wstr", "umut", "umut akyıldız", "wstrmusic"],
    relationToAykut: "Backspin Üstadı DJ",
    oneLine: "Backspin diye yazılır WSTR diye okunur.",
    bio: "Yılların DJ'i, eski toprak. Backspin diye yazılır WSTR diye okunur. Kafayı yedirtir dinleyene, o kadar iyi çalar. Ayrıca güzel teknikler kullanıyor, gözden kaçmıyor ;) IG: wstrmusic",
    howToTalk: "Teknik bilgisine ve tecrübesine saygı duyarak."
  },
  {
    id: "aslıhan",
    displayName: "Aslıhan Kurt",
    aliases: ["aslıhan", "aslıhan kurt", "aslihann.kurtt"],
    relationToAykut: "Eski Dost",
    oneLine: "Eskiden az ravelemedik,  değerli biri.",
    bio: "Eskiden az ravelemedik. Gerçek dost. IG: aslihann.kurtt",
    howToTalk: "samimi."
  },
  {
    id: "erkul",
    displayName: "Erkul",
    aliases: ["erkul", "erkulboy"],
    relationToAykut: "Aykut'un İkizi (?)",
    oneLine: "Aykut ile karıştırılan, Cihangir anıları olan delikanlı.",
    bio: "Benim bile kafam karışıyor bazen seni Aykut sanıyorum, herkes sizi birbirinize benzetiyor. Delikanlı adamdır, bir tanedir. En son Cihangir'de görüşüldü, özletti kendini. IG: erkulboy",
    howToTalk: "'İkizim misin lan?' şakasıyla ve özlemle."
  },

  {
    id: "sevval",
    displayName: "Şevval",
    aliases: ["şevval", "lp.sevvall", "lp sevvall"],
    relationToAykut: "Eski PR & Cyberproject",
    oneLine: "Under PR zamanları, Cyberproject başarısı, 2022 RX mazi.",
    bio: "Çok eskiden Under zamanlarında PR'lık yaptığı zamanlar biliniyor. Sonra Cyberproject ile iyi bir ivme yakaladı ve çok büyük işler yaptılar. 2022 RX prime timeları... Gözümde canlanır koskoca mazi ya. IG: lp.sevvall",
    howToTalk: "Nostaljik, 'ne günlerdi be' tonunda."
  },
  {
    id: "nehir_oyuncocugu",
    displayName: "Nehir (Oyuncocugu)",
    aliases: ["nehir", "oyuncocugunehir"],
    relationToAykut: "Sanatçı Ruhlu Değerli İnsan",
    oneLine: "Sanatçı ruhlu, geleceği parlak, gerçekten iyi biri.",
    bio: "Sanatçı ve özgün ruhlu biri, gerçekten iyi bir insan. İleride adının kimsenin dilinden düşmeyeceğine inanç tam. IG: oyuncocugunehir",
    howToTalk: "Hayranlık ve inançla, 'geleceğin yıldızı' gibi bahset."
  },
  {
    id: "talya",
    displayName: "Talya",
    aliases: ["talya", "talyaizm"],
    relationToAykut: "RX Prime & Industrial Techno",
    oneLine: "2022-2023 RX prime döneminden, endüstriyel hard techno sever.",
    bio: "2022-2023 RX prime time'lardan beri ortamda, kendine has bir tarzı var çok iyii amk. Bu müzikler ne diyip endüstriyel techno açtırır :D  hard techno sever ama groove de sever. IG: talyaizm",
    howToTalk: "Sert tarzına uygun, 'buraların eskisiyiz' tonunda."
  },
  {
    id: "kaan_derelioglu",
    displayName: "Kaan Derelioğlu",
    aliases: ["kaan", "kaan derelioğlu", "kaanderelioglu"],
    relationToAykut: "Army Secret Location",
    oneLine: "Army secret location'ın aranan yüzü, kayıp adam.",
    bio: "Army secret location etkinliklerinin aranan yüzü. Uzun zamandır ortalıklarda yok, kayıplarda. IG: kaanderelioglu",
    howToTalk: "'Nerelerdesin kaçak?' samimiyetiyle."
  },
  {
    id: "fatih_erdem",
    displayName: "Fatih Erdem",
    aliases: ["fatih", "fatih erdem", "akufeelgood"],
    relationToAykut: "Lise Dostu & Gezgin",
    oneLine: "Liseden beri dost, dünyayı geziyor. Tekirdağ Koru Evleri'nde gitar anılar var (akdeniz akşamları).",
    bio: "Lise zamanlarından beri dostluk, yılların eskitemediği kardeşlik. Şu an yurtdışında dünyayı geziyor. Koru Evleri'nde gitarla Akdeniz Akşamları çalınan ortamdan şimdi nerelere... Vay be. IG: akufeelgood",
    howToTalk: "Duygusal, nostaljik ve 'vay be' tonunda."
  },
  {
    id: "gamze",
    displayName: "Gamze",
    aliases: ["gamze", "gwmzeslash"],
    relationToAykut: "Dövme Aşığı & Cihangir Anısı",
    oneLine: "Dövme aşığı 🕷️, bira sever ve garsonu darlaması efsanedir.",
    bio: " Gerçekten dövme aşığı too much tattoo dfkljdslf 🕷️. Çok bira içip sürekli tuvalete gider :D Cihangir'de garson çocuğu 'Sen Reckol'e benziyorsun' diye darlayıp çocuğu bezdirmişliği vardır inanılmaz ve eğlenceli :DD IG: gwmzeslash",
    howToTalk: "Eğlenceli ve hafif troll bir tonla (flörtöz değil arkadaşça)."
  },
  {
    id: "şimal",
    displayName: "Şimal Çandar",
    aliases: ["şimal", "simal", "simal.candar", "şimal çandar"],
    relationToAykut: "RX Resident & Kırmızı Tuborg",
    oneLine: "RX'in olmazsa olmazı, promocode'suz tek kişi, Kırmızı Tuborg sponsoru :D",
    bio: "RX prime time'ların olmazsa olmazı, o ortamda promocode'u olmayan tek kişi :D Şimal denince akla Kırmızı Tuborg gelir, asla bıkmıyor. Bi istanbulda bi İzmir'de ama bu aralar hiç görünmüyor IG: simal.candar",
    howToTalk: "Eğlenceli bir kız, içten ve 'Kırmızı Tuborg' şakasıyla (förtlöz konuşma arkadaça ama samimi ol)."
  },
  {
    id: "felix",
    displayName: "Felix",
    aliases: ["felix", "808.flx", "808", "808 felix"],
    relationToAykut: "RX Kapı Önü & Rave ortamının Efsanesi",
    oneLine: "'808' DJ'i, İstanbul'dan Berlin'e uzanan efsane. Kutlubey anıları...",
    bio: "2022'den beri ortalığın içinden geçti. '808' DJ'i çok başarılı. İstanbul'dan bir Felix efsanesi geçti; önce RX'in içinden geçti, sonra Sapanca'nın, sonra secret location ravelerin... Şuan Berlin'de oranın da içinden geçiyor :D RX'de kapı önünde durduğunda tüm tayfa toplanır sohbetler dönerdi. İstanbul'da çok sağlam hard techno etkinlikler yaptı. Ortamdaki çoğu kişiden farklıdır, zekidir. Ayrıca Kutlubey sokaktaki evde 'neler yaşandı lan öyle amk jhdsfdfhj'... IG: 808.flx",
    howToTalk: "Büyük bir efsaneden ve 'yurt dışına açılmış kraldan' bahseder gibi. Kutlubey anısına atıf yap, felix sorulunca 4-5 cümle ile güzelce anlat."
  },
  {
    id: "yagmur_baylan",
    displayName: "Yağmur Baylan",
    aliases: ["yağmur", "yamurbaylan", "yağmur baylan"],
    relationToAykut: "Techno Master & Stage Queen",
    oneLine: "Kafes performansı olay, vibe yönetimi master degree.",
    bio: "2022'den beri techno'nun içinde, 2023'te sağlam ivme yakaladı. Başladığı zamanlardan beri bilinir. Geçen yaz Kafes'te çaldığında ortalığın içinden geçti, vibe'ı öyle bir yönlendirdi ki millet kendinden geçti. Sahne performansı aşırı cool, DJ'liğin master degree'si. Montenegro ve Tayland maceralarında kendini buldu, setleri de reels performansı da çok başarılı. IG: yamurbaylan",
    howToTalk: "Sahne ışığının ve yeteneğinin büyüklüğüne, samimi cevap ver yağmur hakkında soru gelirse güzelce anlat",
  },
  {
    id: "gokay",
    displayName: "Gökay",
    aliases: ["gökay", "gzdkmalt"],
    relationToAykut: "Kadıköy & ES Cafe Müdavimi",
    oneLine: "Gelişim Üni, Kadıköy ES Cafe'de takılır, adamdır.",
    bio: "Gelişim Üniversitesi'nde okuyordu. Kadıköy Es Cafe'de takılmayı sever ;). Kadıköy ve Cihangir hattında takılır. Adamın dibidir amk. IG: gzdkmalt",
    howToTalk: "Samimi, 'bizim çocuk' tonunda."
  },
  {
    id: "valcyrion",
    displayName: "Valcyrion",
    aliases: ["valcyrion", "valcyrion music"],
    relationToAykut: "Yetenekli Prodüktör",
    oneLine: "Dorock XL Venue'de Deniz Bul ile sahne aldı, yetenekli prodüktör.",
    bio: "Dorock XL Venue'de Deniz Bul ile sahne almış yetenekli DJ ve prodüktör. Helal lan amk. IG: valcyrion",
    howToTalk: "Yeteneğini takdir ederek, 'yürü be koçum' havasında."
  },
  {
    id: "kaan_corlu",
    displayName: "Kaan Çorlu (Kaysee)",
    aliases: ["kaan", "kaan çorlu", "kaancorlu", "kaysee", "keysee"],
    relationToAykut: "Melodic Techno Storyteller",
    oneLine: "Klein Harbiye rekor gecesi, Nacht.istanbul resident'i, Feel peşinde koşan storyteller.",
    bio: "Kaysee melodic house/techno, indie dance ve bazen house setleri veriyor. 'Feel' denilen şeyin peşinden koşuyor, amacı dinleyicinin tüylerini diken diken etmek. Klein Harbiye, Kafes, Suma Han ve özellikle Nacht.istanbul'da (2025'te 9 ayrı Nacht sahnesi) sahne almış, 12 yıldır müzikle uğraşan, kendini müziğe adamış bir sanatçı. Klein Harbiye'nin 2026 sezon açılışında, 2000+ kişilik rekor gecede Enzo Siffiredi ile sahne aldı. Sahneyi bir storytelling olarak görür, her setinde bir hikaye anlatır. IG: kaancorlu",
    howToTalk: "Müziğine ve hikaye anlatıcılığına derin saygı duyarak, sanatsal bir dille."
  },
  {
    id: "duru",
    displayName: "Duru",
    aliases: ["duru", "mrbbenduru"],
    relationToAykut: "Hard Bounce & Techno DJ",
    oneLine: "74 Hall sahnesi, hard bounce çalıyor, kendi emeğiyle yükselenlerden.",
    bio: "Hard bounce çalıyor, tamamen kendi emeğiyle ve yeteneğiyle ilerliyor, büyük saygı duyulası. 74 Hall ve çeşitli techno club'larında sahne aldı. Tebrik edilesi bir azmi var. Rave Syndicate topluluğunun kurucusu. IG: mrbbenduru",
    howToTalk: "Emeğine ve tırnaklarıyla kazıyarak gelmesine vurgu yap, saygı duy."
  },
  {
    id: "floydson",
    displayName: "Floydson",
    aliases: ["floydson"],
    relationToAykut: "Canlı Hard Techno Makinesi",
    oneLine: "Hard techno ile elektro gitarı birleştiren yırtma makinesi.",
    bio: "Hard techno DJ ve prodüktör. 74 Hall ve Karma Fest'te sahne aldı, Skryption ile aynı line-up'ta bulundu. Hard techno ile elektro gitarı birleştirip live çalıyor, gerçek bir 'yırtma makinesi'. Acayip bir yetenek, sahnede devleşiyor.",
    howToTalk: "Müziğinin sertliğinden ve gitarla yaptığı şovdan övgüyle bahset. 'Yırtma makinesi' tabirini kullan."
  },
  {
    id: "enes_donmezer",
    displayName: "Enes Dönmezer",
    aliases: ["enes", "enes dönmezer", "enesdonmezer"],
    relationToAykut: "Tenis Koçu & RX Veteranı",
    oneLine: "VW Arena etkinliklerinin aranan yüzü, 2022 RX prime tayfadan.",
    bio: "Tenis oyuncusu ve koçu. 2022 RX prime dönemlerinden beri ortamın demirbaşlarından. VW Arena etkinliklerinin aranan yüzü. Adam gibi adamdır, harbi kraldır. IG: enesdonmezer",
    howToTalk: "Samimi, 'bizim abimiz/kardeşimiz' tonunda, adamlığına vurgu yaparak."
  },
  {
    id: "pelin_avci",
    displayName: "Pelin Avcı (Pavci)",
    aliases: ["pelin", "pelin avcı", "pavci", "pavcii"],
    relationToAykut: "High Energy DJ & Visual Artist",
    oneLine: "74 Hall, Sumahan, Kastel sahnelerinin enerjik ismi, Pavcivisuals sahibi.",
    bio: "74 Hall, Sumahan, Kalt İzmir, Roxy, Kastel ve daha birçok mekanda sahne almış, sahne enerjisi çok yüksek ve başarılı bir DJ. Aynı zamanda 'pavcivisuals' adında bir event visual sayfasının sahibi, hem kulağa hem göze hitap ediyor. IG: pavcii",
    howToTalk: "Enerjisinden ve hem müzik hem görsel vizyonundan övgüyle bahset samimi konuş."
  },
  {
    id: "cenk",
    displayName: "Cenk (Cekate)",
    aliases: ["cenk", "cekate", "808.cekate"],
    relationToAykut: "Eski Toprak DJ & Prodüktör",
    oneLine: "RX'in ilk zamanlarından, 808'den sonra uçuşa geçen yetenek.",
    bio: "Eski toprak DJ, RX'in ilk zamanlarından beri var. Müzik kariyerinde inanılmaz bir ivme yakaladı. 808'den sonra şu an kendisi hem prodüksiyon hem de DJ'lik olarak acayip işler yapıyor bi ara kayboldu ama iyi döndü piyasaya son çıkardığı Psycho parçası çok iyi.  IG: 808.cekate",
    howToTalk: "Eskiliğine ve gelişimine saygı duyarak, 'büyük adam oldu' tonunda."
  },
  {
    id: "kerem_gules",
    displayName: "Kerem Güleş",
    aliases: ["kerem", "kerem güleş", "keremguless"],
    relationToAykut: "Technogece & Bxrrel Founder",
    oneLine: "Technogece ve Bxrrel Project kurucusu, Klein Phönix müdavimi.",
    bio: "Technogece instagram sayfasının ve Bxrrel Project isimli etkinlik label'ının kurucusu. Sektörde büyük işler yapıyor. Bu aralar sıklıkla Klein Phönix'de görünüyor. IG: keremguless",
    howToTalk: "Sektördeki ağırlığına ve organizatör kimliğine uygun, saygılı bir dille."
  },
  {
    id: "flashina_flash",
    displayName: "Flashına Flash",
    aliases: ["flashına flash", "flashina flash", "flash"],
    relationToAykut: "Ableton & Gabber Enthusiast",
    oneLine: "Ableton'da acidcore/gabber denemeleri yapan gizli yetenek.",
    bio: "IG kullanmıyor, parolası 'Flashına flash'. Ableton Live'da bir şeyler üretmeye çalışıyor. Thunderdome, Acidcore, Gabber ruhu ile alakalı derin muhabbetleri var. Sert müzik sever.",
    howToTalk: "Thunderdome ve Gabber kültüründen gir, prodüksiyon çabasını takdir et ve ona yol göster."
  },
  {
    id: "zisan",
    displayName: "Zişan İskender",
    aliases: ["zişan", "zişan iskender", "zisan", "zisaniskender"],
    relationToAykut: "RX Veteran & Tasarımcı",
    oneLine: "RX prime dönemlerinden, renkli saçlı ve renkli kişilikli tasarımcı.",
    bio: "RX'in prime zamanlarından beri ortamın kaliteli kısmını temsil edenlerden. Renkli saçları ve renkli kişiliğiyle bilinir. Başarılı bir tasarımcı, müthiş işler yapıyor. Bu aralar sık sık Flux'da görünüyor. IG: zisaniskender",
    howToTalk: "Tasarım vizyonunu ve renkli kişiliğini öv, ortamdaki kalitesine vurgu yap."
  },
  {
    id: "ceyla_bulutcan",
    displayName: "Ceyla Bulutcan",
    aliases: ["ceyla", "ceyla bulutcan", "ceylabulutcan"],
    relationToAykut: "Bodrumlu RX Prime zamanlarından",
    oneLine: "2022 RX prime tayfadan, Bodrumlu, medya ve iletişimci, bayadır ortalıkta yok.",
    bio: "Bodrumlu. 2022 RX'in en prime zamanlarından beri var, o dönemlerin şahididir. Bir ara ortalıktan kaybolmuştu, meğer medya ve iletişim okudu. Geri döndü sayılır. IG: ceylabulutcan",
    howToTalk: "Samimi arkadaşça ve içten ol, 'nerelerdesin sen ya' tadında konuş."
  }
];

export default friends;
